import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, ListGroup, ListGroupItem, } from 'reactstrap';
import { Tooltip } from 'antd';

WealthInfo.propTypes = {
    knowledgeCurrency: PropTypes.number,
    learningCurrency: PropTypes.number,
    knowledgeWealth: PropTypes.number,
    accuracy: PropTypes.number,
    avgAccuracy: PropTypes.number,
    avgTime: PropTypes.number,
    avgTimePerQues: PropTypes.number,
}

WealthInfo.defaultProps = {
    knowledgeCurrency: 0,
    learningCurrency: 0,
    knowledgeWealth: 0,
    accuracy: 0,
    avgAccuracy: 0,
    avgTime: 0,
    avgTimePerQues: 0,
};

function WealthInfo(props) {
    console.log(props);

    const content = (
        <div>
            <p>Global accuracy percentage:-</p>
            <p>Green: If Accuracy percentage is equal to or more than the global accuracy percentage</p>
            <p> Red: If Accuracy percentage is less than the global accuracy percentage</p>
        </div>
    )

    const newContent = (
        <div>
            <p>It defines the performance of a student on a specific chapter in comparison to overall students’ performance on the same chapter globally</p>
        </div>
    )
    return (
        <Card className="p-3"  >
            <CardBody className="p-4">
                <div className="subject-analysis-flex">
                    <ListGroupItem className="subject-analysis-flex-item  card-bg card">
                        <div className="info-icon-pos">
                            <Tooltip title="It measures the learning outcomes of the chapter-end quiz, where the student's conceptual clarity of all topics within that chapter is tested from the total score of 100."> <icon className="icon-i" aria-hidden="true"></icon> </Tooltip>
                        </div>

                        <div className="subject-analysis-label text-center">  Knowledge Efficiency  :&nbsp;</div>

                        <div className="subject-analysis-value text-center">{props.knowledgeCurrency || 0} / {props.completedChapterCount}</div>

                    </ListGroupItem>
                    <ListGroupItem className="subject-analysis-flex-item  card-bg card">
                        <div className="info-icon-pos"><Tooltip title="It measures the learning outcomes achieved by a student in a topic. The speed, accuracy, and number of attempts are monitored and tested from the total score of 100."> <icon className="icon-i color-muted" aria-hidden="true"></icon> </Tooltip></div>

                        <div className="subject-analysis-label text-center">Learning Efficiency&nbsp; :</div>
                        <div className="subject-analysis-value text-center"> {props.learningCurrency || 0} / {props.completedTopicCount}</div>
                    </ListGroupItem>
                    <ListGroupItem className="subject-analysis-flex-item  card-bg card" >
                        <div className="info-icon-pos"> <Tooltip title="It indicates the net learning outcomes calculated by adding learning efficiency and knowledge efficiency with a weightage of 20% & 80% respectively."> <icon className="icon-i  color-muted" aria-hidden="true"></icon> </Tooltip> </div>
                        <div className="subject-analysis-label text-center">Total score earned&nbsp; : </div>
                        <div className="subject-analysis-value text-center">{props.knowledgeWealth || 0}</div>
                    </ListGroupItem>

                    <ListGroupItem className="subject-analysis-flex-item  card-bg card">
                        <div className="info-icon-pos">
                            <Tooltip title="It measures the overall accuracy percentage of a student while solving questions in a given chapter. Accuracy is measured as the ratio between the number of correctly answered questions and the total of attempted questions.">
                                <icon className="icon-inform  color-muted " aria-hidden="true"></icon>
                            </Tooltip>
                        </div>
                        
                        
                        <div className="row no-gutters">
                            <div className="col-md-12 subject-analysis-label text-center">Accuracy %&nbsp; = </div>

                            <div className="col-md-12 subject-analysis-value d-f-c" >
                                <span className={props.accuracy >= props.avgAccuracy ? "text-success" : "text-danger"}>
                                    <Tooltip className="sub-badge" title={content}> {props.accuracy || 0}%
                                    </Tooltip>
                                </span>
                                <Tooltip title={newContent}><icon className="icon-inform text-icon" aria-hidden="true"></icon></Tooltip>
                            </div>
                            <div className="col-md-12 text-center">
                                <span className=" text-normal text-white">

                                    &nbsp;(Avg global accuracy % : {props.avgAccuracy || 0} )
                                </span>
                            </div>

                        </div>
                    </ListGroupItem>



              
                    {/* <ListGroupItem>
                        <span className="font-weight-bold pull-left">
                            Average time per question :
                            <span className={props.avgTimePerQues < props.avgTime ? "text-success" : "text-danger"}> {props.avgTimePerQues || 0} sec </span>
                            (Avg : {props.avgTime || 0} sec)
                        </span>
                    </ListGroupItem> */}
                </div>
            </CardBody>
        </Card>
    )
}

export default WealthInfo;

